module.exports = __webpack_public_path__ + "img/Instantly.8e8d7e6a.svg";